import { render } from "./media_dashboard.vue?vue&type=template&id=6020ebb8&scoped=true"
import script from "./media_dashboard.vue?vue&type=script&lang=js"
export * from "./media_dashboard.vue?vue&type=script&lang=js"

import "./media_dashboard.vue?vue&type=style&index=0&id=6020ebb8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6020ebb8"]])

export default __exports__